module.exports = __webpack_public_path__ + "static/media/Cairo-Regular.94c4feb5.ttf";